import { Map } from 'immutable';

import * as t from '../../actions/accountSettingsActionTypes';

const initialState = Map({
  preferences: [],
  isLoadingPreferences: false,
  successSendPreferences: false,
  isLoadingCustomerSite: false,
  error: {},
});

const reducer = function disabledQuesitonsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.LOADING_PREFERENCES:
      return state.set('isLoadingPreferences', action.isLoading);
    case t.LOADING_CUSTOMER_SITE:
      return state.set('isLoadingCustomerSite', action.isLoading);
    case t.SUCCESS_PREFERENCES:
      return state.set('successSendPreferences', action.isSuccess);

    case t.SET_NOTIFICATION_PREFERENCES:
      return state.set('preferences', action.preferences);

    case t.ERROR_PREFERENCES:
      return state.set('error', action.isError);

    case t.SET_SPECIFIC_NOTIFICATION_PREFERENCE:
      let oldPreferences = state.get('preferences');
      oldPreferences = oldPreferences.map((preference) => {
        if (preference.meta_key === action.preference.meta_key) {
          preference = action.preference;
        }
        return preference;
      });
      return state.set('preferences', oldPreferences);

    default:
      return state;
  }
};

export default reducer;
